import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

const LegalLayout = ({ title, updated, children }) => (
  <div className="min-h-screen bg-background">
    <Header />
    <div className="mx-auto max-w-3xl px-5 py-14 lg:px-8">
      <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-4 w-4" /> Back to home
      </Link>
      <h1 className="mt-4 font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl">{title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">Last updated: {updated}</p>
      <div className="mt-8 space-y-6 text-sm leading-relaxed [&_h2]:font-heading [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-foreground [&_p]:text-muted-foreground [&_li]:text-muted-foreground">
        {children}
      </div>
    </div>
    <Footer />
  </div>
);

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 2026">
      <section>
        <h2>1. The service</h2>
        <p>
          VisaFlight provides a confirmed airline reservation (itinerary) for use as visa application documentation. This
          is not a purchased airline ticket. The reservation's validity is determined by the airline and reservation
          system.
        </p>
      </section>
      <section>
        <h2>2. No guarantee of visa approval</h2>
        <p>
          VisaFlight does not guarantee visa approval. Visa decisions are made solely by the relevant embassy, consulate
          or visa authority. Documentation requirements vary by country and visa category, and customers are responsible
          for confirming the current requirements for their specific application before ordering.
        </p>
      </section>
      <section>
        <h2>3. Customer responsibilities</h2>
        <p>
          You are responsible for providing accurate passenger and travel information. Please review your details
          carefully before payment. VisaFlight is not liable for errors resulting from inaccurate information provided by
          the customer.
        </p>
      </section>
      <section>
        <h2>4. Processing times</h2>
        <p>
          Standard orders are delivered within 24 hours, Express within 4 hours, and Priority within 1 hour. Processing
          times begin only after successful payment and receipt of all required information.
        </p>
      </section>
      <section>
        <h2>5. Changes</h2>
        <p>
          One itinerary change is included with every reservation. Additional changes after the included change are
          charged at ₦10,000 each.
        </p>
      </section>
      <section>
        <h2>6. Payments</h2>
        <p>
          Payments are processed securely through Paystack. Prices are fixed per service tier and cannot be altered by the
          customer at checkout.
        </p>
      </section>
      <section>
        <h2>7. Not an airline or embassy</h2>
        <p>
          VisaFlight is an independent reservation service. It is not an airline, travel agency ticket seller, embassy or
          government authority.
        </p>
      </section>
    </LegalLayout>
  );
}
